import { create } from 'zustand';
import axiosInstance from '../../../configs/axios';
import { ApiPath } from '../../../constants/apiPath';
import { NotificationListModel, NofificationListFilter } from '../../notificationList/model/notification-list-model';
import { axiosErrorMessage } from '../../../utils/error-message';
import { AxiosError } from 'axios';
import { NotificationModel } from '../../notification/model/notification-model';
export interface NotificationListControllerState {
  listNotification: NotificationListModel[] | [],
  listCount: number,
  message: string | null,
  loading: boolean,
  filter: NofificationListFilter | null,
  page: number,
  pageRowAmount: number,
  selected: NotificationModel | null;
}

export interface NotificationListControllerAction {
  notificationListGetData: (startLoading?: boolean, filter?: NofificationListFilter | null) => void;
  onPageChange: (page: number, rows: number) => void;
  onFilterChange: (filter?: NofificationListFilter | null) => void;
  onDelete: (id: string) => void,
}
export const RoleController = create<NotificationListControllerState & NotificationListControllerAction>()(
  (set) => ({
    loading: false,
    listNotification: [],
    message: null,
    listCount: 0,
    page: 0,
    pageRowAmount: 8,
    filter: { skip: 0, take: 8 },
    activeModal: null,
    formCreate: null,
    formUpdate: null,
    currentModal: null,
    selected: null,
    notificationListGetData: async (startLoading?: boolean, filter?: NofificationListFilter | null) => {
      try {
        if (startLoading)
          set(() => ({ loading: true }));

        const res = await axiosInstance.get(ApiPath.notifications.all, { params: filter ?? { skip: 0, take: 8 } })
        const filteredData: any = res?.data?.data ?? [];

        const filteredDataTotal: any = res?.data?.count ?? 0;
        set(() => ({ listNotification: filteredData, listCount: filteredDataTotal }));
      } catch (error) {
        set(() => ({ message: axiosErrorMessage({ error: error as AxiosError }) }));
      } finally {
        if (startLoading)
          setTimeout(() => set(() => ({ loading: false })), 500);
      }
    },
    onPageChange: (page: number, rows: number) => {
      set(() => ({ pageRowAmount: rows, page: page }));
    },
    onFilterChange(filter?: NofificationListFilter | null) {
      set(() => ({ filter: filter }));
      this.notificationListGetData(true, filter);
    },
    async onDelete(id: string) {
      try {
        set(() => ({ loading: true }));
        const res = await axiosInstance.delete(ApiPath.notifications.delete(id));


        if (res?.status === 200) {
          this.notificationListGetData(true, null);
        } else {
          set(() => ({ message: res?.statusText }));
        }
      } catch (error) {
        set(() => ({ message: axiosErrorMessage({ error: error as AxiosError }) }));
      } finally {
        setTimeout(() => set(() => ({ loading: false })), 500);
      }
    },
  })
);

export default RoleController;